import {
  APPLIANCE_FETCH_STARTED,
  APPLIANCE_FETCH_SUCCEEDED,
  APPLIANCE_FETCH_FAILED,
  APPLIANCE_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  appliance: { project: {} },
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case APPLIANCE_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case APPLIANCE_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        appliance: action.payload
      };
    case APPLIANCE_FETCH_FAILED:
      return { ...state, status: statuses.failed, appliance: { project: {} }, error: action.error };
    case APPLIANCE_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
